import { Chip, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type VersionChipProps = {
    version: string;
    isLatest?: boolean;
};

export function VersionChip({ version, isLatest }: VersionChipProps) {
    return (
        <Tooltip
            enterDelay={1000}
            title={
                isLatest ? (
                    <FormattedMessage
                        id="tooltip.latestVersion"
                        defaultMessage="Latest version"
                    />
                ) : (
                    <FormattedMessage
                        id="tooltip.oldVersion"
                        defaultMessage="Newer version is available"
                    />
                )
            }
        >
            <Chip
                variant="outlined"
                size="small"
                color={isLatest ? 'primary' : 'warning'}
                label={version}
                sx={{
                    cursor: 'default',
                    fontSize: 10,
                    height: 18,
                    px: 0.5,
                }}
            />
        </Tooltip>
    );
}
